module.exports = __webpack_public_path__ + "media/about/UnitedWayLogo-29cdbb18.png";